import { connect } from 'react-redux'
import { isEmpty } from 'lodash'

import SuitesStaff from '../../components/SuitesStaff'

import { loadSuitesStaff } from '../../store/Staff/actions'
import { loadAttendantSettings } from '../../store/AppDeviceConfiguration/actions'
import {
  getAttendants,
  getFilterAttendantStatus,
  getSearchSuitesStaffValue,
} from '../../store/Staff/selector'
import { getAttendantSettingsByEmployeeUuid } from '../../store/AppDeviceConfiguration/selector'
import { getCurrentVenueUuid } from '../../store/Venues/selector'
import { makeGetEmployeeRole } from '../../store/EmployeeRole/selector'
import { fetchEmployeeRoles } from '../../store/EmployeeRole/actions'

const mapStateToProps = ( state, ownProps ) => {
  const attendants = getAttendants(state)
  const attendantSettings = getAttendantSettingsByEmployeeUuid(state)
  const currentVenueUuid = getCurrentVenueUuid(state)
  const searchSuitesStaffValue = getSearchSuitesStaffValue(state)
  const getEmployeeRole = (attendant) => {
    const legacyRole = makeGetEmployeeRole()(state, attendant?.employeeId)
    return isEmpty(legacyRole) ? makeGetEmployeeRole()(state, attendant?.id) : legacyRole
  }
  const attendantStatusFilterValue = getFilterAttendantStatus(state)

  return {
    attendants,
    attendantSettings,
    attendantStatusFilterValue,
    currentVenueUuid,
    getEmployeeRole,
    searchSuitesStaffValue,
  }
}

const mapDispatchToProps = {
  loadSuitesStaff,
  loadAttendantSettings,
  fetchEmployeeRoles: (venueUuid) => fetchEmployeeRoles(venueUuid),
}

export default connect(mapStateToProps, mapDispatchToProps)(SuitesStaff)
